import axios from 'axios';

export const fetchLogList = async (offset: number = 0, size: number = 10) => {
    return axios.get(`log?offset=${offset}&limit=${size+1}`);
}
